import {ICCSplitInvoiceItem} from '@secca/shared/models/ICCInvoiceSplit/i-c-c-split-invoice-item';
import {ServiceOrderService} from '@secca/core/services/service-order.service';
import {DropdownDictionary} from '@secca/shared/models/dropdownDictionary';
import {ServiceOrder} from '@secca/shared/models/service-order/service-order';
import {ServiceItemType} from '@secca/shared/models/service-item-type';

export interface ICCSplitEntryEvents {
  itemAmountChanged(): void;
}

export class ICCSplitEntry {
  service: ServiceOrderService;
  item: ICCSplitInvoiceItem;
  selectedCaseId: string;
  serviceItems: DropdownDictionary[] = [];
  serviceOrders: ServiceOrder[];
  serviceItemTypes: ServiceItemType[];
  exchangeRate: number;
  itemAmountEvent: ICCSplitEntryEvents;

  constructor(service: ServiceOrderService,
              splitInvoiceItem: ICCSplitInvoiceItem,
              serviceItemsTypes: ServiceItemType[],
              exchangeRate: number,
              itemAmountEvent: ICCSplitEntryEvents) {
    this.service = service;
    this.item = splitInvoiceItem;
    this.serviceItemTypes = serviceItemsTypes;
    this.exchangeRate = exchangeRate;
    this.loadServiceOrders();
    this.selectedCaseId = this.item.caseId + '';
    this.itemAmountEvent = itemAmountEvent;
  }

  caseChanged(): void {
    this.item.caseId = +this.selectedCaseId;
    this.item.serviceOrderId = null;
    this.loadServiceOrders();
  }

  serviceOrderChanged(): void {
    this.item.serviceItemName = null;
    this.item.serviceItemCode = null;
    this.loadServiceItems();
  }

  amountChanged(): void {
    this.item.splitOriginalInvoiceMoney.amount = Number((this.item.splitMoney.amount * this.exchangeRate).toFixed(2));
    this.itemAmountEvent.itemAmountChanged();
  }

  serviceItemChanged(selection: string): void {
    const selectedServiceItem = this.serviceItems.find(serviceItem => serviceItem.id === selection);
    this.item.serviceItemName = selectedServiceItem.name;
  }

  documentChanged(id: string, name: string): void {
    this.item.documentId = id;
    this.item.documentName = name;
  }

  loadServiceOrders(): void {
    if (this.item.caseId) {
      this.service.getServiceOrdersForSupplierInvoice(this.item.caseId).subscribe(serviceOrders => {
        this.serviceOrders = serviceOrders;
        this.loadServiceItems();
      });
    }
  }

  loadServiceItems(): void {
    if (this.item.serviceOrderId) {
      const serviceOrder = this.serviceOrders.find(order => order.serviceOrderId === this.item.serviceOrderId);
      this.serviceItems = this.serviceItemTypes
        .filter(item => item.sosServiceTypes.includes(serviceOrder.type) && item.iccSplit)
        .map(item => new DropdownDictionary(item.id, item.name));
    }
  }
}
